module.exports = __webpack_public_path__ + "static/img/corsss.34558d7d.png";